export default {
  route: {
    dashboard: 'Dashboard',

    customer:'Basic Management',
    customerInfo:'CustomerInfo',
    batch:'BatchManagement',
    batchInfo:'BatchInfo',
    roleManagement:'RoleManagement',
    basic:'BasicSetting',
    menuManagement:'MenuManagement',
    logManagement:'LogManagement',
    stockDetail:'StockDetail',
    stockData:'StockData',
    costTransfer:'CostTransfer',
    BillingInformation:'BillingInformation',
    contractRelated:'contract Related',
    companyAccountList:'Company AccountList',
    invoiceManagement:'Invoice Management',
    CollectionInformation:'Collection Information Management',
    refundManagement:'refund Management',
    dataVerification:'Data Verification',
    MissingBatch:'MissingBatch',
    ProjectSummary:'ProjectSummary',
    ownerInformation:'ownerInformation',
    BillAndCollectChecked:'Bill & Collect Checked',
    batchDetailsDownload:'Batch Details Download',
    OperationReconciliationLag:'Operation Reconciliation Lag',
    DownLoadApply:'DownLoad Apply',
    PingAnBatch:'Pingan Batch',
    thirdPartBenefits:'third Part Benefits',
    supplierContractList:'ConstractList',
    supplierManagement:'supplierManagement',
    supplierContractDetail:'supplier ContractDetail',
    supplierContractEdit:'supplier ContractEdit',
    supplierContractAdd:'supplier ContractAdd',
    paymentManagement:'payment Management',
    supplierAccountInformation:'supplier Account Information',
    billReceiptManagement:'bill Receipt Management',
    supplierDownLoadApply:'supplier_DownLoadApply',
    returnManagement:'return Management',
    dolphinDetails:'dolphin Details',
    cloudxDetails:'cloudx Details',
    BatchReleaseFounds: 'batch release founds',
    wxsnapshot:'wxsnapshot',
    pinganMerchant: 'pinganMerchant',
    merchantTask: 'merchantTask',
    merchantList:'merchantList',
    cloudxStockManagement: 'cloudxStockManagement',
    cloudxBatchQuery: 'cloudxBatchQuery',
    cloudxBatchDetail: 'cloudxBatchDetail',
    seal: 'seal',
    sealManagemant: 'seal Managemant',
    bidReview:'BidReview',

  },
  login: {
    logIn: 'Log in',
    username: 'Administrator name',
    password: 'Administrator password',
    validcode: 'Image verification code',
    val_username: 'Please enter the administrator name!',
    val_password: 'Please enter the administrator password!',
    val_validcode: 'Please enter the image verification code!',
    val_form: 'Fill in the form is incorrect, please check!'
  },
  tagsView: {
    close: 'Close',
    closeOthers: 'Close Others',
    closeAll: 'Close All'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js